import { Button , Modal } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { bindDispatch } from '../common/util/redux'
import BasicModal from '../components/common/BasicModal'
import TheatreIcon from '../icons/theatre.svg'
import CompositionSearch from '../components/compositions/CompositionSearch'
import CompositionList from '../components/compositions/List'
import '../style/listHeader.less';
import MovieDetails from '../components/compositions/MovieDetails'
import Theatres from '../components/theatres/List'
import { shouldRefetchData } from '../actions/refetchData'
import {
  REFETCH_COMPOSITION_TIME,
  UPDATE_REFETCH_TIMEOUT,
} from '../common/config'
import monarch from '../common/client/monarch'

class MoviesPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modalValue: false,
      movieModal: false,
      movieId: '',
      movieLoading: true,
      movieFetchError: false,
      movieDetails:''
    }
  }

  componentDidMount(){
    this.shouldRefresh()
    document.body.addEventListener("mouseover", this.handleKeyPress);
  }

  checkTimer = async () => {
    let {
      timeStamp,
      fetchingData
    } = this.props
    if(timeStamp && !fetchingData){
      if(shouldRefetchData(timeStamp)){
        await this.fetchAgain()
        await this.updateRefetchTime(parseInt(REFETCH_COMPOSITION_TIME, 10))
        await this.shouldRefresh()
      }
      else {
        this.shouldRefresh()
      }
    }
    else {
      this.updateRefetchTime(parseInt(REFETCH_COMPOSITION_TIME, 10))
      this.shouldRefresh()
    }
  }

  shouldRefresh = () => {
    setTimeout(() => this.checkTimer() , 3000);
  }

  handleKeyPress = () => {
    this.updateRefetchTime(parseInt(UPDATE_REFETCH_TIMEOUT, 10))
  }

  fetchAgain = async () => {
    let {
      refetchCompostions,
      isDataFetching
    } = this.props.actions
    await refetchCompostions()
    await isDataFetching(true)
  }

  updateRefetchTime = (intervel) => {
    let {
      updateRefreshTime
    } = this.props.actions
    let expireTime = new Date().setSeconds( new Date().getSeconds() + intervel);
    updateRefreshTime(expireTime)
  }

  closeMovieModal = () => {
    this.setState({movieModal: false})
  }

  openMovieModal = (value) => {
    this.setState({
      movieModal: true,
      movieId: value,
      movieLoading: true,
      movieFetchError: false
    }, () => this.fetchMovieDetails(value))
  }



  fetchMovieDetails = (value) => {
    let url = `v1/movies/${this.state.movieId}`
    return monarch.get(url)
      .then((res) => {
        if(res.status == 200){
          this.setState({
            movieLoading: false,
            movieDetails: res.data
          })
        }
        else {
          this.setState({movieLoading: false , movieFetchError: true})
        }
      })
  }

  getCompositionOptions () {
    const {compositions: {enabledExpandAll}, actions: {toggleExpandCollapseAll}} = this.props
    return (
      <div className="inbox-header-expand-view">
        {/*<Col span={7}>
          <CompositionFilter showModal={this.props.actions.showModal}/>
        </Col>
        <Col span={7}>
          <CompositionSortOption/>
        </Col> */}
        <div className="header-filter-mobile" onClick={() => this.openFilterView()}>
         <TheatreIcon style={{fontSize: 10}}/>
         <p>Theatres</p>
        </div>
        <Button type='primary' ghost onClick={() => toggleExpandCollapseAll(!enabledExpandAll)}>
          {
            enabledExpandAll ?
            I18n.t('compositions.collapseAll')
            : I18n.t('compositions.expandAll')
          }
        </Button>
      </div>
    )
  }

  openFilterView = () => {
    this.setState({modalValue: !this.state.modalValue})
  }

  render () {
    const {theatres, compositions, modal, compositionFilters, user} = this.props
    const {
      fetchTheatres, fetchCompositions, toggleTheatreFilter, showModal, hideModal,
      toggleSideBar, sendKDMEmail, updateTheatreSearchQuery, clearTheatreSearchQuery,
      downloadKDMs, updateCplsToOpenTheatres, loadTheatreDetails, updateSearchText
    } = this.props.actions
    let{
      movieLoading,
      movieDetails,
      movieFetchError
    } = this.state
    return (
      <div className="movie-page">

        <div className="header-overview" id="inbox-search-header">
          <div className="inbox-header-heading">
            <p>{I18n.t('pages.movies')}</p>
          </div>
          <div className="inbox-header-search">
            <CompositionSearch onSearch={updateSearchText} fetchCompositions={fetchCompositions}/>
          </div>
          {this.getCompositionOptions()}
        </div>

        <div className="composition-list-view">
         <div className={theatres.showSideBar ? "composition-with-filter":"composition-without-filter"}>
           <CompositionList
             compositions={compositions}
             fetchCompositions={fetchCompositions}
             showModal={showModal}
             selectedTheatres={theatres.selectedTheatres}
             compositionFilters={compositionFilters}
             toggleTheatreFilter={toggleTheatreFilter}
             theatres={theatres}
             sendKDMEmail={sendKDMEmail}
             downloadKDMs={downloadKDMs}
             updateCplIds={updateCplsToOpenTheatres}
             loadTheatreDetails={loadTheatreDetails}
             user={user}
             openMovieModal={(value) => this.openMovieModal(value)}
             movieModal={this.state.movieModal}
           />
         </div>
         <div className={theatres.showSideBar ? "filter-fullview":"filter-hiddenview"}>
           <Theatres
             theatres={theatres}
             fetchTheatres={fetchTheatres}
             toggleTheatreFilter={toggleTheatreFilter}
             toggleSideBar={toggleSideBar}
             compositionFilters={compositionFilters}
             updateTheatreSearchQuery={updateTheatreSearchQuery}
             clearTheatreSearchQuery={clearTheatreSearchQuery}
           />
         </div>
         <BasicModal
           modal={modal}
           hideModal={hideModal}
         />
         <Modal
          title="Filter By Theatres"
          onCancel={this.openFilterView}
          visible={this.state.modalValue}
          className='antd-modal-style-override'
          footer={null}>
            <Theatres
              theatres={theatres}
              fetchTheatres={fetchTheatres}
              toggleTheatreFilter={toggleTheatreFilter}
              toggleSideBar={toggleSideBar}
              compositionFilters={compositionFilters}
              updateTheatreSearchQuery={updateTheatreSearchQuery}
              clearTheatreSearchQuery={clearTheatreSearchQuery}
            />
          </Modal>

          <Modal
           title="Movie Details"
           className='antd-modal-style-override'
           width='55%'
           onCancel={this.closeMovieModal}
           visible={this.state.movieModal}
           footer={null}>
             <MovieDetails
               loading={movieLoading}
               error={movieFetchError}
               imageUrl={movieDetails && movieDetails.posterUrl}
               name={movieDetails && movieDetails.name}
               year={movieDetails && movieDetails.year}
               language={movieDetails && movieDetails.language}
               genres={movieDetails && movieDetails.genres && movieDetails.genres[0]}
               synopsis={movieDetails && movieDetails.shortSynopsis}
             />
           </Modal>

       </div>

      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    theatres: state.theatres,
    compositions: state.compositions,
    compositionFilters: state.compositionFilters,
    modal: state.modal,
    user: state.user,
    timeStamp: state.compositions.timestamp,
    fetchingData: state.compositions.fetching
  }
}

export default connect(
  mapStateToProps,
  bindDispatch
)(MoviesPage)



// WEBPACK FOOTER //
// ./src/app/pages/Movies.js